const TOKEN_KEY = 'token';
const SESSION_TOKEN_KEY = 'session_token';
const STORAGE_MODE_KEY = 'token_storage_mode';

function getLegacyToken() {
  return sessionStorage.getItem(SESSION_TOKEN_KEY) || localStorage.getItem(TOKEN_KEY) || null;
}

export function getToken() {
  const mode = localStorage.getItem(STORAGE_MODE_KEY);
  if (mode === 'session') {
    return sessionStorage.getItem(SESSION_TOKEN_KEY) || getLegacyToken();
  }
  if (mode === 'local') {
    return localStorage.getItem(TOKEN_KEY) || getLegacyToken();
  }
  return getLegacyToken();
}

export function saveToken(token, { sessionOnly = false } = {}) {
  if (!token) return;
  if (sessionOnly) {
    sessionStorage.setItem(SESSION_TOKEN_KEY, token);
    localStorage.removeItem(TOKEN_KEY);
    localStorage.setItem(STORAGE_MODE_KEY, 'session');
    return;
  }
  localStorage.setItem(TOKEN_KEY, token);
  sessionStorage.removeItem(SESSION_TOKEN_KEY);
  localStorage.setItem(STORAGE_MODE_KEY, 'local');
}

export function removeToken() {
  sessionStorage.removeItem(SESSION_TOKEN_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(STORAGE_MODE_KEY);
}

export function getAdminToken() {
  return getToken();
}
